import { IApplicationContext } from '../../../common/types/applicationContext';
import { ResponseError } from '../../../common/errors/responseError';
import { IRatingParamsProps } from '../../../common/types/ratingParams';
import { TRating } from '../../../common/types/rating';

export async function fetchRatingData(
  { httpApi, logger }: IApplicationContext,
  { region, date, type }: IRatingParamsProps,
): Promise<TRating[] | null> {
  try {
    const { response, statusCode } = await httpApi.fetch({
      apiType: 'external',
      microserviceName: 'info-api',
      assertStatusCodes: [200, 400, 500],
      method: 'POST',
      pathApi: '/api/agencies-rating/v1/get-rating-data',
      parameters: { regionSlug: region, dateRating: date, typeRating: type },
    });

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: 'info',
        message: response,
      });
    }

    return response;
  } catch (ex) {
    logger.error(ex);

    return null;
  }
}
